import {
  DriverSalaryAdjustmentsDetail,
  DriverSalaryAdjustmentsDetailRequest,
  DriverSalaryAdjustmentsInfoItem,
  DriverSalaryAdjustmentsItem,
} from 'bus/driverSalaryAdjustments/types';

import { PayloadRequest } from 'types/requestTypes';

import $axios from '../utils/axios-instance';

export default class DriverSalaryAdjustmentsApi {
  async getDriverSalaryAdjustments(data: PayloadRequest) {
    return await $axios
      .get<DriverSalaryAdjustmentsItem>(`/v1/driverTonarAdjustments/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createDriverSalaryAdjustments(data: DriverSalaryAdjustmentsItem) {
    return await $axios
      .post('/v1/driverTonarAdjustments/', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async editDriverSalaryAdjustments(data: DriverSalaryAdjustmentsItem) {
    return await $axios
      .put(`/v1/driverTonarAdjustments/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteDriverSalaryAdjustments(data: PayloadRequest) {
    return await $axios
      .delete(`/v1/driverTonarAdjustments/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getDriverSalaryAdjustmentsInfo(data: PayloadRequest) {
    return await $axios
      .get<DriverSalaryAdjustmentsInfoItem>(`/v1/driverTonarAdjustments/${data.id}/info`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  //detail
  async getDriverSalaryAdjustmentsDetailList(data: PayloadRequest) {
    return await $axios
      .get<DriverSalaryAdjustmentsDetail[]>(`/v1/driverTonarAdjustments/${data.id}/details`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getDriverSalaryAdjustmentsDetailOne(data: PayloadRequest) {
    return await $axios
      .get<DriverSalaryAdjustmentsDetail>(`/v1/driverTonarAdjustments/details/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createDriverSalaryAdjustmentsDetail(data: DriverSalaryAdjustmentsDetailRequest) {
    return await $axios
      .post(`/v1/driverTonarAdjustments/${data.adjustmentId}/details`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async editDriverSalaryAdjustmentsDetail(data: DriverSalaryAdjustmentsDetailRequest) {
    return await $axios
      .put(`/v1/driverTonarAdjustments/details/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteDriverSalaryAdjustmentsDetail(data: PayloadRequest) {
    return await $axios
      .delete(`/v1/driverTonarAdjustments/details/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
